module.exports = __webpack_public_path__ + "static/media/img-14.9e078014.jpg";